module.exports = __webpack_public_path__ + "static/media/bars.febae3c6.svg";